import React from 'react';
import  '../common/status.css';


function indicator(d, icontype){
  let icon;
  if(icontype ==='r'){
    icon =(<i className="is-red fas fa-times fa-2x"></i>)
  }else if(icontype === 'g'){
    icon = (<i className="is-green fas fa-check fa-2x"></i>)
  }else if(icontype === 'y'){
    icon = (<i className="is-yellow fas fa-minus fa-2x"></i>)
  }else if(icontype === 'u'){
    icon = (<i className="unkown-status fas fa-question fa-2x"></i>)
  }
  return (
    <div className='status-item'>
        {icon}<span>{d}</span>
    </div>
  )
}


export const HealthStatusCount = props => {
  const counts = props.counts || {} 
  let red= counts.RED;
  let green= counts.GREEN;
  let yellow= counts.YELLOW;
  let unknown= counts.UNKNOWN;

  let undiv='';
  if(unknown){
    undiv = indicator(unknown, 'u')
  }
  return (
    <div className="status-wrapper">
      {red!==undefined && indicator(red,'r')}
      {yellow!==undefined &&
          indicator(yellow, 'y')
      }
      {green!==undefined && indicator(green,'g')}
      {undiv}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/data/status/common/healthStatusCount.js